import { useState } from "react";
import { AuthContext } from "./contexts/AuthContext";
import { IAuthProviderProps } from "../types/IAuthProviderProps";

const AuthProvider = (props: IAuthProviderProps) => {
    type PersistState = boolean;

    const { children, authService } = props;
    const [email, setEmail] = useState<string | "">("");
    const [firstName, setFirstName] = useState<string | "">("");
    const [upi, setUpi] = useState<string | "">("");
    const [roles, setRoles] = useState<string[] | []>([]);
    const [employeeID, setEmployeeID] = useState<string | "">("");
    const [lastName, setLastName] = useState<string | "">("");
    const [accessToken, setAccessToken] = useState<string | "">("");
    const [notificationType, setNotificationType] = useState<number>(0);
    const [persist, setPersist] = useState<PersistState>(
        JSON.parse(localStorage.getItem("persist") || 'false') as PersistState
    );

    const getInitials = () => {
        return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    }

    return (
        <AuthContext.Provider value={{authService, email, firstName, upi, employeeID, lastName, accessToken, setAccessToken, setLastName, setEmployeeID, setUpi, setEmail, setFirstName, roles, persist, setPersist, setRoles, getInitials, notificationType, setNotificationType}} >
            { children }
        </AuthContext.Provider>
    )
}

export default AuthProvider;